import React from "react";
import styles from "./Delete.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { MdDelete } from "react-icons/md";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice"; // Adjust path as needed

const Delete = () => {
  const dispatch = useDispatch();

  const handleConfirm = () => {
    console.log("Confirmed Deletion");
    // Optionally dispatch(deleteItem(id)) or API call
    dispatch(closeModal());
  };

  const handleCancel = () => {
    console.log("Cancelled Deletion");
    dispatch(closeModal());
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.modalHeader}>
        <HeadingAndIcon
          icon={<MdDelete  color="Orange" />}
          heading="Delete"
        />
      </div>

      <div className={styles.modalBody}>
        <p className={styles.textMain}>Are you sure to Delete?</p>
        <p className={styles.textSub}>Click yes to delete</p>
      </div>

      <div className={styles.modalFooter}>
        <SaveAndCancel
          onCancel={handleCancel}
          onSave={handleConfirm}
          saveLabel="Yes"
          cancelLabel="No"
        />
      </div>
    </div>
  );
};

export default Delete;
